class HighchartClass {
    constructor(data) {

    }
    // 计算最大值，最小值，平均值
    static calculateMaxMinAvg(data) {
        let arr = data.list || []
        // 提取所有data数组中的item[1]值
        const allValues = [];

        arr.forEach(item => {
            if (item && item.data && Array.isArray(item.data)) {
                item.data.forEach(dataItem => {
                    if (Array.isArray(dataItem) && dataItem.length > 1) {
                        allValues.push(dataItem[1]);
                    }
                });
            }
        });
        if (allValues.length === 0) {
            return {};
        }
        // 计算最大值，最小值，平均值
        let max = Math.max(...allValues);
        let min = Math.min(...allValues);
        let avg = allValues.reduce((acc, val) => acc + val, 0) / allValues.length || 0;
        return { max, min, avg }
    }
    //配置上下限标线(完成)
    static plotLines(data, chart) {
        if (chart) {
            // console.log('chart', chart.options.yAxis.plotLines = [])
            // chart.options.yAxis.plotLines = []
            // chart.options.yAxis = []

        }
        // 清空之前的plotLines

        let arr = data || []
        // 提取所有data数组中的item[1]值
        const min = []
        const max = []

        arr.forEach(item => {
            if (item && item.data && Array.isArray(item.data)) {
                item.data.forEach(dataItem => {
                    if (Array.isArray(dataItem) && dataItem.length > 1) {
                        min.push(dataItem[3]);//温度下限
                        max.push(dataItem[2]);//温度上限
                    }
                });
            }
        });

        var arrmax = [...new Set(max)]
        var arrmin = [...new Set(min)]

        arrmax.forEach(item => {
            arr.push({
                color: '#FF1D00', //线的颜色，定义为红色
                dashStyle: 'solid', //默认值，这里定义为实线 虚线DashDot
                value: item, //定义在那个值上显示标示线，这里是在x轴上刻度为3的值处垂直化一条线
                width: 2, //标示线的宽度，2px
                label: {
                    text: `温度上限（${item}℃）`, //标签的内容
                    align: 'right', //标签的水平位置，水平居左,默认是水平居中center
                    // x: 10 //标签相对于被定位的位置水平偏移的像素，重新定位，水平居左10px
                }
            })
        })
        arrmin.forEach(item => {
            arr.push({
                color: '#FF1D00', //线的颜色，定义为红色
                dashStyle: 'solid', //默认值，这里定义为实线 虚线DashDot
                value: item, //定义在那个值上显示标示线，这里是在x轴上刻度为3的值处垂直化一条线
                width: 2, //标示线的宽度，2px
                label: {
                    text: `温度下限（${item}℃）`, //标签的内容
                    color: '#FF7804', //线的颜色，定义为红色
                    align: 'right', //标签的水平位置，水平居左,默认是水平居中center
                    // x: 10 //标签相对于被定位的位置水平偏移的像素，重新定位，水平居左10px
                }
            })
        })

        return arr;
    }

    static upLines(val, data) {
        console.log('arrData', val, data)
        let arr = data || []
        let up = []//温度上限
        let low = []//温度下限

        let min = []//温度或湿度
        arr.forEach(item => {
            val == "max" ? up.push(item.data[item.data.length - 1][2]) : low.push(item.data[item.data.length - 1][3])
            if (item && item.data && Array.isArray(item.data)) {
                item.data.forEach(item => {
                    if (Array.isArray(item) && item.length > 1) {
                        min.push(item[1]);//温度
                    }
                });
            }
        });
        return val == "max" ? Math.max(...up) > Math.max(...min) ? Math.max(...up) : Math.max(...min) : Math.min(...low) < Math.min(...min) ? Math.min(...low) : Math.min(...min)
    }


}


export default HighchartClass